import { format } from 'date-fns'

export function formatCreatedAt(created_at) {
  return format(new Date(`${created_at}Z`), 'MMM d, yyyy · h:mm aa')
}
